import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useDeleteCalendarMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`calendars/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendars'] });
    },
  });

  const deleteCalendar = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteCalendar,
    isLoading,
    error,
  };
};
